module.exports = __webpack_public_path__ + "static/media/5.10_preview.d2781b69.png";